import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MaterialLayoutComponent } from './material.component';
import { ClipboardComponent } from '../../../common/clipboard/clipboard.component';
import { FuseFullscreenModule } from '../../../../../@fuse/components/fullscreen/fullscreen.module';
import { FuseLoadingBarModule } from '../../../../../@fuse/components/loading-bar/loading-bar.module';
import { FuseNavigationModule } from '../../../../../@fuse/components/navigation/navigation.module';
import { LanguagesModule } from '../../../common/languages/languages.module';
import { MessagesModule } from '../../../common/messages/messages.module';
import { SettingsModule } from '../../../common/settings/settings.module';
import { UserModule } from '../../../common/user/user.module';
import { SystemChangesComponent } from '../../../common/system-changes/system-changes.component';
import { SharedModule } from '../../../../shared/shared.module';
import { WsMessagesComponent } from '../../../common/ws-messages/ws-messages.component';

@NgModule({
    declarations: [
        MaterialLayoutComponent
    ],
    imports     : [
        ClipboardComponent,
        HttpClientModule,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        FuseFullscreenModule,
        FuseLoadingBarModule,
        FuseNavigationModule,
        LanguagesModule,
        MessagesModule,
        SettingsModule,
        UserModule,
        SystemChangesComponent,
        SharedModule,
        WsMessagesComponent,
    ],
    exports     : [
        MaterialLayoutComponent
    ]
})
export class MaterialLayoutModule
{
}
